import type { RegionDistrictEntity } from './RegionDistrictEntity'

export class DistrictEntity {
  regionId?: number
  regionName?: string | null
  districts?: Array<RegionDistrictEntity> | null
}
